export default __webpack_public_path__ + "static/media/right_blur591.aff974c0.png";